import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import { AnyAction, Dispatch, ThunkDispatch } from "@reduxjs/toolkit";
import { AppDispatch, RootState } from "../../store/store";

export const useAppDispatch = (): ThunkDispatch<RootState, undefined, AnyAction> & Dispatch =>
  useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
